import createReactComponent from '../createReactComponent';
export default createReactComponent('test-pipe-2', 'IconTestPipe2', [
  ['path', { d: 'M15 3v15a3 3 0 0 1 -6 0v-15', key: 'svg-0' }],
  ['path', { d: 'M9 12h6', key: 'svg-1' }],
  ['path', { d: 'M8 3h8', key: 'svg-2' }],
]);
